import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-component-input-file',
    templateUrl: './input-file.component.html',
    styleUrls: ['./input-file.component.scss']
})
export class InputFileComponent implements OnInit {

    @Output('file') public file: EventEmitter<any> = new EventEmitter<any>();
    public fileName: string;

    constructor() {
    }

    ngOnInit(): void {
    }

    setFile(event): void {
        const arr = event.target.files[0].name.split('.');
        arr[arr.length - 1] = arr[arr.length - 1].toLowerCase();
        if (arr[arr.length - 1] !== 'docx') {
            return;
        }
        this.fileName = event.target.files[0].name;
        this.file.emit(event.target.files[0]);
    }
}
